import { render, staticRenderFns } from "./tab-verify.vue?vue&type=template&id=12ac9d8b&"
import script from "./tab-verify.vue?vue&type=script&lang=js&"
export * from "./tab-verify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports